import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {AccountNs, AuthenticationNs} from "@shared/types";
import {useAccountStore} from "@domains/account/stores/account.store";
import {toast} from '@shared/ms-components'

export const confirmDeleteAccountResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
  const isAuthPage = window.location.href.indexOf('/auth/') > -1;
  const payload = {
    confirmationCode: to.query.ac,
    userId: to.query.un
  } as AccountNs.ConfirmDeleteAccountRequest;


  const accountStore = useAccountStore();
  accountStore.confirmDeleteAccount(payload).then(() => {
    toast.success('Account has been deleted');
  }).finally(() => {
    next({name: AuthenticationNs.AuthenticationRouteEnums.Logout});
  })
};
